module.exports = __webpack_public_path__ + "img/group-l.443ab2a9.svg";